// NPM imports
import React from "react";
import { Tooltip } from "@revvsales/components";

// Internal Imports
import { GRID } from "../../constants";
import { numberForamting } from "../../utils/globalUtils";

// Destructuring
const { PRICING_METHODS } = GRID;

export default function PriceMatrixDepedencyRenderer(props) {
  const value = props.value
    ? numberForamting(props.value, props.colDef.currencySymbol)
    : `${props.colDef.currencySymbol}0`;
  if (
    props.data &&
    props.data.metaData &&
    !props.data.metaData.value &&
    props.data.metaData.type !== PRICING_METHODS.NON_LINEAR &&
    props.data.metaData.type !== PRICING_METHODS.DIY_PRICING
  ) {
    return (
      <Tooltip
        placement="top"
        overlay={<div>Base price is dependant on total quantity selected</div>}>
        <div className="dependencynotify-pin">{value}</div>
      </Tooltip>
    );
  }
  if (
    props.data &&
    props.data.metaData &&
    props.data.metaData.value &&
    props.data.metaData.isAdhoc
  ) {
    return (
      <Tooltip
        placement="top"
        overlay={
          <div>
            This is an ad-hoc SKU. Click the green cell under QUANTITY to enter
            effort for resources
          </div>
        }>
        <div className="dependencynotify-pin">{value}</div>
      </Tooltip>
    );
  }
  return <div>{value}</div>;
}



// WEBPACK FOOTER //
// ./src/components/AgGridCellRenderer/PriceMatrixDepedencyRenderer.js